/**
 * @generated SignedSource<<83745e61e3bc7052d739418e60ff1c9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FinancialCalculationTrigger_viewer$data = {
  readonly project: {
    readonly id: string;
    readonly financialCalculationTrigger: {
      readonly timestamp: number | null;
      readonly duration: number | null;
      readonly isSmallProject: boolean | null;
    } | null;
  } | null;
  readonly " $fragmentType": "FinancialCalculationTrigger_viewer";
};
export type FinancialCalculationTrigger_viewer$key = {
  readonly " $data"?: FinancialCalculationTrigger_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FinancialCalculationTrigger_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FinancialCalculationTrigger_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialCalculationTrigger",
          "kind": "LinkedField",
          "name": "financialCalculationTrigger",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSmallProject",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0c635187570cf003cfe9df1651b09431";

export default node;
